import { Component, h } from 'preact'
import Axios from 'axios'

/* eslint-disable import/no-internal-modules */
import FeaturedImageAttachment from '@insided/deprecated-control/category/Attachments'
import Panel from '@insided/deprecated-control/panel'

interface Props {
  contentType: string
  privateId: number
  featuredImage?: string
}

interface State {
  featuredImage?: string
}

class FeaturedImagePanel extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      featuredImage: props.featuredImage
    }
    this.onChangeFeaturedImage = this.onChangeFeaturedImage.bind(this)
  }

  async onChangeFeaturedImage (newFeaturedImage: null | { source_thumb: string }) {
    const { privateId, contentType } = this.props
    const newValue: string = newFeaturedImage === null ? '' : newFeaturedImage.source_thumb
    await Axios.post(`/community/api/${contentType}s/${privateId}/editFeaturedImage`, {
      featuredImage: newValue
    }).then(() => this.setState({ featuredImage: newValue }))
  }

  render () {
    const { featuredImage } = this.state
    return (
      <Panel collapsible title='Featured image' customClass='featured-image_panel'>
        <FeaturedImageAttachment
          label='Maximum file size: 5M. Allowed image types: .jpg, .jpeg, .png, .gif. We recommend a minimum of 1440*640px'
          className='featured-image'
          isAttachmentSelected={featuredImage}
          imageSrc={featuredImage}
          width={1440}
          height={640}
          onUpdate={async (data: null | { source_thumb: string }) => await this.onChangeFeaturedImage(data)}
        />
      </Panel>
    )
  }
}

export default FeaturedImagePanel
